export function commonFunc() {
  $('.tab').click(function () {
    $('.active').removeClass('active');
    $(this).addClass('active');
    $('.isShow').removeClass('isShow');
    // クリックしたタブからインデックス番号を取得
    const index = $(this).index();
    // クリックしたタブと同じインデックス番号をもつコンテンツを表
    $('.content').eq(index).addClass('isShow');
  });
}